import React, { useMemo } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useField } from 'formik'
import { Box, Text } from '@mantine/core'

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
}

export default function RichTextEditor ({ name, label, placeholder }: Props) {
  const [field, meta, helpers] = useField(name)

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['blockquote', 'link'],
        [{ color: [] }, { background: [] }],
        ['clean']
      ]
    }),
    []
  )

  return (
    <Box className="rich-text-field" sx={{ marginBottom: 12 }}>
      {label && (
        <Text size="sm" weight={500} mb={4}>
          {label}
        </Text>
      )}
      <ReactQuill
        theme="snow"
        value={field.value || ''}
        onChange={(value) => helpers.setValue(value)}
        onBlur={() => helpers.setTouched(true)}
        placeholder={placeholder}
        modules={modules}
        className="rich-text-editor"
      />
      {meta.touched && meta.error && (
        <Text size="sm" color="red" mt={4}>
          {meta.error}
        </Text>
      )}
    </Box>
  )
}
